import { connect } from "react-redux";
import AddToCart from "./addToCart";
import { bindActionCreators } from "redux";
import { addInCart } from "services/redux/brandActivtion/products/action"

const mapStateToProps = (state) => {
  return ({
    viewCart: state.productsReducer.viewCart
});}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ addInCart }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AddToCart);
